import { createActionsHook, createHook, createStore } from 'react-sweet-state';

import { type StoreChatItem } from '../types';

type State = Record<string, StoreChatItem[]>;

const store = createStore({
	name: 'chatUseMessages',
	initialState: {} as State,
	actions: {
		setMessages:
			(conversationId: string, messages: StoreChatItem[]) =>
			({ setState }) => {
				setState({ [conversationId]: messages });
			},
		getMessages:
			(conversationId: string) =>
			({ getState }) => {
				return getState()[conversationId] ?? [];
			},
	},
});

export const useChatMessages = createHook(store, {
	selector: (state, { conversationId }: { conversationId: string }) => state[conversationId] ?? [],
});
export const useChatMessagesActions = createActionsHook(store);
